import React, { BaseSyntheticEvent, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@dls/react-core';
import { deleteStudy, Study } from '../../api/studykit';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import {
  StyledDialogHeading,
  StyledDialogIconContainer,
  StyledDialogTitleForIcon,
} from '../styled/styles';
import { Icon } from '@dls/react-icon';
import { ColorX11 } from '../../styling/color';

interface RemoveStudyDialogProps {
  study: Study;
  open: boolean;
  onClose: () => void;
}

export const RemoveStudyDialog: React.FC<RemoveStudyDialogProps> = ({ study, open, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    deleteStudy(study.id)
      .then(() => {
        navigate(`/${RoutePaths.Studies}/ongoing`);
      })
      .catch(console.error)
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <StyledDialogTitleForIcon disableTypography>
        <StyledDialogIconContainer>
          <Icon name={'DeleteTrash'} size={'m'} color={ColorX11.Black} />
        </StyledDialogIconContainer>
        <StyledDialogHeading variant={'h3'}>Are you sure?</StyledDialogHeading>
      </StyledDialogTitleForIcon>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove the following study?
          <br />
          <br />
          {study.name}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <form onSubmit={onSubmit}>
          <Button
            disabled={isSubmitting}
            type={'button'}
            onClick={onClose}
            dls_variant={'quietEmphasis'}
          >
            Cancel
          </Button>
          <Button
            disabled={isSubmitting}
            style={{ marginLeft: `8px` }}
            type={'submit'}
            dls_variant={'signalError'}
          >
            Delete
          </Button>
        </form>
      </DialogActions>
    </Dialog>
  );
};
